import {customCopilotIdsAreEqual, useRouteSpaceId} from '@github-ui/copilot-chat-helpers/custom-copilots-helpers'
import {getSelectedThread} from '@github-ui/copilot-chat-state/get-selected-thread'
import type {CopilotSpaceId} from '@github-ui/copilot-chat-types'
import {copilotSpaceIdFromThread} from '@github-ui/copilot-spaces/utils/copilot-space-id-from-thread'
import {useRef} from 'react'

import {useChatStateLens} from '../utils/CopilotChatContext'

/**
 * Pulls the selected custom copilot (space) from either the URL or the selected thread per the chat state.
 */
export function useSelectedCopilotSpaceId(): CopilotSpaceId | null {
  // state.thread changes more frequently than the custom copilot ID, so we do some work to try to memoize the value
  const previousValue = useRef<CopilotSpaceId | null>(null)
  const customCopilotId = useChatStateLens(state => {
    const thread = getSelectedThread(state)
    const id = copilotSpaceIdFromThread(thread)
    // because copilotSpaceIdFromThread returns a new object each time, we have to do additional work to make sure the lens doesn't trigger unnecessarily
    if (customCopilotIdsAreEqual(previousValue.current, id)) {
      return previousValue.current
    } else {
      previousValue.current = id
      return id
    }
  })
  return useRouteSpaceId() || customCopilotId
}
